module.exports = __webpack_public_path__ + "img/cash-received-by-distributor.912b3d4a.svg";